<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="help" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title>Contact Us</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Our Contact Information:
    </ion-list-header>

    <ion-list>
        <ion-item data-test="companyName">
            <ion-label class="ion-text-wrap">
                <span class="line1">Company Name</span><br />
                <span class="line2">ShuttleNomix</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="phoneNumber">
            <ion-label class="ion-text-wrap">
                <span class="line1">Phone Number</span><br />
                <span class="line2">{{contactUs.phoneNumber}}</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="officeHours">
            <ion-label class="ion-text-wrap">
                <span class="line1">Office Hours</span><br />
                <span class="line2">{{contactUs.companyHours}}</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="website">
            <ion-label class="ion-text-wrap">
                <span class="line1">Website</span><br />
                <span class="line2">{{contactUs.website}}</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="emailAddress">
            <ion-label class="ion-text-wrap">
                <span class="line1">Email Address</span><br />
                <span class="line2">{{contactUs.emailAddress}}</span>
            </ion-label>
        </ion-item>
        <!-- <ion-item>
          <span class="line1">Help Desk</span><br />
          <span class="line2">{{contactUs.helpdesk}}</span>
      </ion-item> -->

        <ion-item data-test="maintenanceHours">
            <ion-label class="ion-text-wrap">
                <span class="line1">Maintenance Hours</span><br />
                <span class="line2">{{contactUs.maintenanceHours}}</span><br />
                <span class="line2">
                    Periodically, we will need to perform routine maintenance to the software.
                    To minimize the impact on our users, these updates will occur during these maintenance hours.<br />
                    Thank you for understaning.
                </span>        
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>